import { newModalFromString } from '../components/modal';
import accordion from '../components/accordion';
import { parseHtml, moveModalCloseButton, updateColorFamily, updatePrices, updateAvailability, updateOptions, updateQuantities, isMiniCartOpen, isChooseBonusProductModalOpen, isQuickUpdateFromModal, isMobileDevice } from '../product/base';
import { getListId } from '../analytics/helpers/helper';

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
const createErrorNotification = (message) => {
    var errorHtml = '<div class="cart-alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
};

function formatDate (date) {
    return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
    date.getFullYear();
}

const updateImageChooseBonusProductModal = ($productContainer, product) => {
    $productContainer.find('.js-image-chooseBonusProduct').attr('src', product.images.small[0].url);
    $productContainer.find('.js-image-chooseBonusProduct').attr('alt', product.images.small[0].url);
    $productContainer.find('.js-image-chooseBonusProduct').attr('title', product.images.small[0].title);
};

const updateProceedButtonQuickUpdateModal = ($productContainer, data, url, skuOld) => {
    $productContainer.find('.js-proceed-quickUpdate-modal').data('href', url);
    $productContainer.find('.js-proceed-quickUpdate-modal').data('pid', data.product.id);
    $productContainer.find('.js-proceed-quickUpdate-modal').data('quantity', data.product.selectedQuantity);
    $productContainer.find('.js-proceed-quickUpdate-modal').data('sku-old', skuOld);
};

const updateProceedButtonChooseBonusProductModal = ($productContainer, data, url) => {
    $productContainer.find('.js-proceed-chooseBonusProduct-modal').data('href', url);
    $productContainer.find('.js-proceed-chooseBonusProduct-modal').data('pid', data.product.id);
    $productContainer.find('.js-proceed-chooseBonusProduct-modal').data('quantity', data.product.selectedQuantity);
    $productContainer.find('.js-proceed-chooseBonusProduct-modal').data('ready-to-order', data.product.readyToOrder);
};

const _setupBonusProductsListeners = (_self, modal) => {
    const isMobile = false;
    const initChooseBonusProductModal = (_self, modal, isMobile) => {
        const $modalContainer = $(modal.modalBox);

        // Adjust lines based on buttons' size
        const sizeButtons = document.querySelectorAll('.js-size-variation');
        sizeButtons.forEach(button => {
            if (button.textContent.includes('-')) {
                $('.cc-quickUpdateModal-sizeWrapper-btn').css('--lines', '3');
            }
        });

        // Select the first color

        var bonusProductItems = $('.bonus-product-item');
        for (var i = 0; i < bonusProductItems.length; i++) {
            var bpi = bonusProductItems.eq(i);
            var isVariant = $(bpi).eq(0).data('isVariant');

            const $colorOptions = bpi.find('[data-attr-type-qu="color"] .js-color-variation:not(.disabled)');
            const $alreadySelectedColor = bpi.find('[data-attr-type-qu="color"] .js-color-variation.selected');

            if ($colorOptions.length >= 1 && $alreadySelectedColor.length === 0) {
                $($colorOptions[0]).click();
            }

            // Disable size accordion
            bpi.find('[data-attr-type-qu="size"] .accordion-title').addClass('disabled');
            // Disable proceed button
            bpi.find('.js-proceed-chooseBonusProduct-modal').addClass('disabled');
            if (isVariant) {
                // Disable color accordion
                bpi.find('[data-attr-type-qu="color"] .accordion-title').addClass('disabled');
                // Enable size accordionspiegami punto per punto
                bpi.find('[data-attr-type-qu="size"] .accordion-title').removeClass('disabled');
            } else {
                // Update select color label
                bpi.find('[data-attr-type-qu="color"] .family-color').data('value', '').text('').hide();
                bpi.find('[data-attr-type-qu="color"] .selected-attribute-label').data('value', '').text('').hide();
                bpi.find('[data-attr-type-qu="color"] .not-selected-attribute-label').show();
            }

            // Update select size label
            bpi.find('[data-attr-type-qu="size"] .selected-attribute-label').data('value', '').text('').hide();
            bpi.find('[data-attr-type-qu="size"] .not-selected-attribute-label').show();
        }

        let step = 'colorAndSize';
        if (isMobile) {
            // Set first modal step as 'startPersonalization'
            step = 'startPersonalization';
            $modalContainer.find('.js-variationAttributes-container').hide();
            $modalContainer.addClass('rightModalAttribute');
            $modalContainer.find('.js-back-chooseBonusProduct-modal').hide();
            $modalContainer.find('.js-sizeContainer').hide();

            // Retrieve selected variation url
            const selectedColorUrl = $modalContainer.find('.js-color-variation.selected').attr('href');
            $modalContainer.find('.js-proceed-chooseBonusProduct-modal').attr('href', selectedColorUrl);
            // Enable proceed button
            $modalContainer.find('.js-proceed-chooseBonusProduct-modal').removeClass('disabled');
        }

        // Set first modal step
        $modalContainer.data('step', step);

        const promotionDetails = $('.js-chooseBonusProductModal').data('promotionDetails');
        $(modal.modalBox).find('.js-chooseBonusProduct-promoDetails').data('value', promotionDetails).text(promotionDetails);
    };
    const closeBonusProductModal = (modal) => {
        $(modal.modalBox).on('click', '.js-close-button', (e) => {
            e.preventDefault();
            const bonusProductModal = _self.getBonusProductModal();
            if (isMiniCartOpen() && bonusProductModal) {
                bonusProductModal.close();
                bonusProductModal.destroy();
            }
            modal.close();
            modal.destroy();
        });
    };

    const proceedChooseBonusProduct = (modal, isMobile) => {
        $(modal.modalBox).on('click', '.js-proceed-chooseBonusProduct-modal', (e) => {
            e.preventDefault();
            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            $.spinner().start();
            const $modalContainer = $(modal.modalBox);
            const $productContainer = $(e.currentTarget).closest('.product-detail');

            const newProductId = $(e.currentTarget).data('pid');
            const addToCartUrl = $('.js-chooseBonusProductModal').data('addToCartUrl');
            const uuid = $('.js-chooseBonusProductModal').data('uuid');
            const pliuuid = $('.js-chooseBonusProductModal').data('pliuuid');
            $modalContainer.data('addToCartUrl', addToCartUrl);

            const selectedColor = $productContainer.find('[data-attr-type-qu="color"] .selected-attribute-label').data('value');
            const selectedSize = $productContainer.find('[data-attr-type-qu="size"] .selected-attribute-label').data('value');

            const step = $modalContainer.data('step');
            let nextStep;
            switch (step) {
            case 'startPersonalization':
                $modalContainer.find('.js-proceed-startPersonalization-container').hide();
                $modalContainer.find('.js-title-chooseBonusProduct-container').hide();
                $modalContainer.find('.js-image-chooseBonusProduct-container').hide();

                $modalContainer.find('.js-variationAttributes-container').show();

                nextStep = isMobile ? 'color' : 'colorAndSize';
                $modalContainer.data('step', nextStep);
                break;

            case 'colorAndSize':
                if ((selectedColor && selectedColor !== '') && (selectedSize && selectedSize !== '')) {
                    $modalContainer.data('addToCartUrl', addToCartUrl);
                    $.spinner().stop();
                    $('body').trigger('cart:addBonusProduct', {
                        newProductId: newProductId,
                        container: $modalContainer,
                        uuid: uuid,
                        pliuuid: pliuuid
                    });
                }
                if ((selectedColor && selectedColor !== '') && (!selectedSize || selectedSize === '')) {
                    $('body').trigger('product:sizeNotSelected', {
                        container: $productContainer
                    });
                    $('body').trigger('product:forceQuickUpdateSizeSelection', {
                        container: $productContainer
                    });
                }
                break;

            case 'color':
                $(modal.modalBox).find('.js-sizeContainer').hide();

                // Retrieve selected variation url
                const selectedColorUrl = $(modal.modalBox).find('.js-color-variation.selected').attr('href');
                $(modal.modalBox).find('.js-proceed-chooseBonusProduct-modal').attr('href', selectedColorUrl);

                if (selectedColor && selectedColor !== '') {
                    $modalContainer.find('.js-colorContainer').hide();
                    $modalContainer.find('.js-sizeContainer').show();
                    $modalContainer.find('.js-back-chooseBonusProduct-modal').show();

                    if (!selectedSize || selectedSize === '') {
                        $('body').trigger('product:sizeNotSelected', {
                            container: $productContainer
                        });
                        $('body').trigger('product:forceQuickUpdateSizeSelection', {
                            container: $productContainer
                        });
                    }

                    nextStep = 'size';
                    $modalContainer.data('step', nextStep);
                }
                break;

            case 'size':
                if ((selectedColor && selectedColor !== '') && (selectedSize && selectedSize !== '')) {
                    $modalContainer.data('addToCartUrl', addToCartUrl);
                    $.spinner().stop();
                    $('body').trigger('cart:addBonusProduct', {
                        newProductId: newProductId,
                        container: $modalContainer,
                        uuid: uuid,
                        pliuuid: pliuuid
                    });
                }
                break;

            default: break;
            }

            $.spinner().stop();
        });
    };

    const backChooseBonusProduct = (modal) => {
        $(modal.modalBox).find('.js-back-chooseBonusProduct-modal').on('click', (e) => {
            const $modalContainer = $(modal.modalBox);

            $modalContainer.find('.js-back-chooseBonusProduct-modal').hide();
            $modalContainer.find('.js-sizeContainer').hide();
            $modalContainer.find('.js-colorContainer').show();
            $modalContainer.data('step', 'color');
            // enable proceed button
            $modalContainer.find('.js-proceed-chooseBonusProduct-modal').removeClass('disabled');
        });
    };

    const enableBonusProductSelection = () => {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));
            var pid = response.product.id;
            $('button.select-bonus-product').data('pid', pid);
        });
    };

    const addBonusProductsToCart = (_self) => {
        $('body').on('cart:addBonusProduct', function (e, data) {
            var $productContainer = data.container;
            var url = $productContainer.data('addToCartUrl');

            var queryString = '?pids=';
            var pid = data.newProductId;
            var uuid = data.uuid;
            var pliuuid = data.pliuuid;

            var pidsObject = {
                bonusProducts: [{
                    pid: decodeURI(pid),
                    qty: 1,
                    options: [null],
                    GTMItemListName: 'free_product',
                    GTMItemListId: getListId($productContainer),
                    GTMIndex: 0
                }],
                totalQty: 1
            };

            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + uuid;
            queryString = queryString + '&pliuuid=' + pliuuid;

            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: data => {
                    if (data.error) {
                        createErrorNotification(data.errorMessage);
                        $.spinner().stop();
                    } else {
                        var bonusProductPid = JSON.parse(JSON.parse('{"' + decodeURIComponent(data.queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}').pids).bonusProducts[0].pid;
                        $('body').trigger('product:afterAddToCart', {
                            ...data,
                            form: {
                                pid: bonusProductPid,
                                quantity: pidsObject.bonusProducts[0].qty
                            },
                            $productContainer: 'bonus_product'
                        });
                    }
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        });
    };

    initChooseBonusProductModal(_self, modal, isMobile);
    closeBonusProductModal(_self, modal);
    proceedChooseBonusProduct(modal, isMobile);
    backChooseBonusProduct(modal);
    enableBonusProductSelection();
    addBonusProductsToCart(_self);
};

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
const chooseBonusProducts = (_self, data) => {
    let bonusUrl = data.bonusChoiceRuleBased ? data.showProductsUrlRuleBased : data.showProductsUrlListBased;
    var selectedSize = data.preselectedSize;

    const isMobile = false;
    bonusUrl += '&isMobile=' + isMobile;

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: rsp => {
            const modalContent = parseHtml(rsp.renderedTemplate).body;
            const modal = newModalFromString(modalContent, false, ['cc-bonusProductModal', 'js-chooseBonusProductModal'], null, function () {
                $('.js-cart-size-notSelected').hide();
            });

            $('.js-chooseBonusProductModal').data('addToCartUrl', data.addToCartUrl);
            $('.js-chooseBonusProductModal').data('uuid', data.uuid);
            $('.js-chooseBonusProductModal').data('pliuuid', data.pliUUID);
            $('.js-chooseBonusProductModal').data('promotion-details', data.promotionDetails);
            $('.js-chooseBonusProductModal').data('moreURL', data.showProductsUrlRuleBased);
            $('.js-chooseBonusProductModal').data('bonusChoiceRuleBased', data.bonusChoiceRuleBased);

            if (isMobile) {
                $(modal.modal).addClass('cc-quickUpdateModal');
            }

            $(modal.modalBox).addClass('rightModalAttribute');
            if ($('.layer-minicart-modal').hasClass('tingle-modal--visible')) {
                $(modal.modalBox).addClass('minicart-style');
            }

            _setupBonusProductsListeners(_self, modal);

            modal.open();
            accordion.setup($('.js-accordion-modal-init'));

            $(modal.modalBox).on('click', '.js-close-button', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });

            _self.methods.setBonusProductModal(modal);

            // Prevent scroll issue on iOS
            // document.body.style.top = null;
            $('.bonus-product').trigger('change');
            if (selectedSize !== '') {
                $('.js-chooseBonusProductModal li[data-size-value="' + selectedSize + '"]').trigger('click');
            }

            $.spinner().stop();

            $('body').trigger('bonusProduct:quickviewOpen', { products: rsp.products });
        },
        error: () => {
            $.spinner().stop();
        }
    });
};

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
const processSwatchValuesQuickUpdate = (attr, $productContainer, type) => {
    const selector = `[data-attr-qu="${attr.id}"]`;

    $productContainer.find('.js-dangerLabel-soldOut').hide();
    // Update color selection modal
    attr.values.forEach(attrValue => {
        const $attrValue = $productContainer.find(`${selector} [data-attr-value="${attrValue.value}"]`);

        // update attribute label
        $attrValue.find('.attribute-label').text(attrValue.description.toLowerCase() + ' - ' + attrValue.value.toLowerCase() + ' - ' + attrValue.displayValue.toLowerCase());

        if (attrValue.selected) {
            if ($attrValue[0]) {
                $productContainer.find(`[data-opener="${attr.id}"] .attribute-selection`).html($attrValue[0].outerHTML);
                $attrValue.addClass('selected');

                $('body').trigger('product:colorSelected', {
                    container: $productContainer,
                    value: attrValue.value,
                    description: attrValue.description
                });

                if ((!attrValue.selectable || attrValue.isSoldOut) && isMobileDevice()) {
                    $productContainer.find('.js-dangerLabel-soldOut').show();
                }
            }
        } else {
            $attrValue.removeClass('selected');
            if ((!attrValue.selectable || attrValue.isSoldOut) && !isMobileDevice()) {
                $productContainer.find('.js-dangerLabel-soldOut').show();
            }
        }

        if (attrValue.url) {
            $attrValue.attr('href', attrValue.url);
        } else {
            $attrValue.removeAttr('href');
        }

        if (attrValue.isSoldout) {
            $attrValue.addClass('soldout');
        } else {
            $attrValue.removeClass('soldout');
        }
    });
};

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
const processNonSwatchValuesQuickUpdate = (attr, $productContainer, type) => {
    const selector = `[data-attr-qu="${attr.id}"]`;
    const $selectedAttr = $productContainer.find(`[data-attr-type-qu="${type}"] .selected-attribute-label`);
    $selectedAttr.data('value', '').text('');

    // Update size selection modal
    attr.values.forEach(attrValue => {
        const $anchor = $productContainer.find(`${selector} [data-attr-value="${attrValue.value}"]`);
        const $attrValue = $anchor.closest('li');

        $attrValue.removeClass('disabled');

        if (attrValue.selected && attrValue.selectable) {
            $productContainer.find(`[data-opener="${attr.id}"] .attribute-selection`).html(attrValue.displayValue);

            $attrValue.addClass('size-button--selected cc-quickUpdateModal-sizeWrapper-btn_selected');
            $('body').trigger('product:sizeSelected', {
                container: $productContainer,
                value: attrValue.displayValue
            });
        } else {
            $attrValue.removeClass('size-button--selected cc-quickUpdateModal-sizeWrapper-btn_selected');
        }

        if (attrValue.url) {
            $anchor.attr('href', attrValue.url);
        } else {
            $anchor.removeAttr('href');
        }

        if (!attrValue.selectable) $attrValue.addClass('disabled');

        if ($('#isNotifyActive').val() === 'true') {
            if (!attrValue.selectable || attrValue.isComingSoon) {
                $attrValue.find('.attribute-label').addClass('notifyMePlp');
                $attrValue.find('.attribute-label svg').show();
            } else {
                $attrValue.find('.attribute-label').removeClass('notifyMePlp');
                $attrValue.find('.attribute-label svg').hide();
            }
        }
    });
};

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {string} variantType - Size or Color selection
 * @param {jQuery} $productContainer - DOM element for a given product
 */
const updateAttrsQuickUpdate = (attrs, $productContainer) => {
    // Currently, the only attribute type that has image swatches is Color.
    const attrsWithSwatches = ['color'];

    attrs.forEach(attr => {
        if (attrsWithSwatches.indexOf(attr.attributeId) > -1) {
            processSwatchValuesQuickUpdate(attr, $productContainer, 'color');
        } else {
            processNonSwatchValuesQuickUpdate(attr, $productContainer, 'size');
        }
    });
};

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
const handleVariantResponseQuickUpdate = (response, $productContainer, imagesShouldUpdate = true) => {
    const isChoiceOfBonusProducts = isChooseBonusProductModalOpen();
    if (response.product.variationAttributes) {
        // updates colors and sizes selected/onsale/...
        updateAttrsQuickUpdate(response.product.variationAttributes, $productContainer);
        updateColorFamily(response.product, $productContainer);
    }
    // Update pricing
    if (!isChoiceOfBonusProducts && response.product.price) {
        updatePrices(response.product, $productContainer, response.resources);
    }
    updateAvailability(response, $productContainer);
    if (isChooseBonusProductModalOpen()) {
        const $sizeOptions = $productContainer.find('[data-attr-type-qu="size"] .js-size-variation:not(.disabled)');
        const $alreadySelectedSize = $productContainer.find('[data-attr-type-qu="size"] .js-size-variation.size-button--selected');

        if ($sizeOptions.length > 0 && $alreadySelectedSize.length === 0) {
            $($sizeOptions[0]).click();
        }
    }
};

/**
 * updates the product view when a product attribute of quickAdd is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {string} type - type of filter selected
 */
const attributeSelectQuickUpdate = (selectedValueUrl, $productContainer, type = '_', imagesShouldUpdate = true, skuOld) => {
    if (selectedValueUrl) {
        $.spinner().start();
        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: data => {
                handleVariantResponseQuickUpdate(data, $productContainer, imagesShouldUpdate);
                updateOptions(data.product.options, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                $productContainer.attr('data-pid', data.product.id);

                const selectedColor = $productContainer.find('[data-attr-type-qu="color"] .selected-attribute-label').data('value');
                const selectedSize = $productContainer.find('[data-attr-type-qu="size"] .selected-attribute-label').data('value');
                if (!selectedColor) {
                    $('body').trigger('product:colorNotSelected', {
                        container: $productContainer
                    });
                }

                if (isQuickUpdateFromModal()) {
                    updateProceedButtonQuickUpdateModal($productContainer, data, selectedValueUrl, skuOld);
                    $.spinner().stop();
                } else if (isChooseBonusProductModalOpen()) {
                    updateProceedButtonChooseBonusProductModal($productContainer, data, selectedValueUrl);
                    updateImageChooseBonusProductModal($productContainer, data.product);

                    if (!isMobileDevice() && (selectedColor && selectedColor !== '') && (!selectedSize || selectedSize === '')) {
                        $('body').trigger('product:sizeNotSelected', {
                            container: $productContainer
                        });
                        $('body').trigger('product:forceQuickUpdateSizeSelection', {
                            container: $productContainer
                        });
                    }
                    if ((selectedColor && selectedColor !== '') && (!selectedSize || selectedSize === '') && $('.js-sizeTU').length) {
                        $('.js-sizeTU').click();
                    }

                    $.spinner().stop();
                } else {
                    if ((selectedColor && selectedColor !== '') && (selectedSize && selectedSize !== '')) {
                        if ($productContainer.data('isBonusProduct') === true) {
                            $('body').trigger('product:quickUpdateBonusProduct', {
                                newProductId: data.product.id,
                                container: $productContainer
                            });
                        } else if ($productContainer.data('isSaveForLater') === true) {
                            $('body').trigger('product:quickUpdateProductSaveForLater', {
                                newProductId: data.product.id,
                                container: $productContainer,
                                skuOld: skuOld
                            });
                        } else {
                            $('body').trigger('product:quickUpdateProduct', {
                                newProductId: data.product.id,
                                container: $productContainer
                            });
                        }
                    }

                    if ((selectedColor && selectedColor !== '') && (!selectedSize || selectedSize === '')) {
                        $('body').trigger('product:sizeNotSelected', {
                            container: $productContainer
                        });
                        $('body').trigger('product:forceQuickUpdateSizeSelection', {
                            container: $productContainer
                        });
                        $.spinner().stop();
                    }
                }
            },
            error: () => {
                $.spinner().stop();
            }
        });
    }
};

class QuickUpdateSingleton {
    constructor () {
        if (!QuickUpdateSingleton.instance) {
            this.freeGiftDetailsModal = 'freeGiftDetailsModal';
            this.bonusProductModal = null;
            this.methods = {
                getBonusProductModal: () => {
                    return this.bonusProductModal;
                },
                setBonusProductModal: (modal) => {
                    this.bonusProductModal = modal;
                },
                chooseBonusProducts: (data) => {
                    chooseBonusProducts(this, data);
                }
            };
            this._init_();

            QuickUpdateSingleton.instance = this;
        }
        return QuickUpdateSingleton.instance;
    }

    _init_ () {
        this.quickUpdateListener();
        this.quickUpdateProduct();
        this.bonusProductListeners();
        this.showFreeGiftDetails();
    }

    static getInstance () {
        if (!this.instance) {
            this.instance = new QuickUpdateSingleton();
        }

        return this.instance;
    }

    bonusProductListeners () {
        var _self = this;
        $('body').on('click', '.cart-page .wrapper-bonus-product-button', function (e) {
            e.preventDefault();
            $.spinner().start();
            $.ajax({
                url: $(this).data('url'),
                method: 'GET',
                dataType: 'json',
                success: function (data) {
                    if (data.noedit) {
                        location.reload();
                    } else {
                        _self.methods.chooseBonusProducts(data);
                    }
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    }

    quickUpdateProduct () {
        var _self = this;
        $('body').on('product:quickUpdateProduct', function (e, data) {
            e.preventDefault();
            var $productContainer = data.container;

            var updateProductUrl = $productContainer.data('productUpdateUrl');
            var uuid = $productContainer.data('uuid');
            var pid = data.newProductId;

            var form = {
                uuid: uuid,
                pid: decodeURI(pid),
                quantity: 1
            };

            const isGiftCardProduct = $(e.currentTarget).data('giftcard');
            if (isGiftCardProduct) {
                // Validate price
                let amountSelectorOk = true;
                if ($('.js-amount-selector.active').length === 0 || $('.js-amount-selector.active').data('amount') === 0) {
                    $('.js-price-validation-error-not-selected').removeClass('hidden');
                    amountSelectorOk = false;
                }

                let errors = [];
                let container = $('.parsleyValidatableElement');
                for (let i = 0; i < container.length; i++) {
                    let validator = container.eq(i).parsley();
                    validator.validate();
                    if (!validator.isValid()) {
                        errors.push(validator);
                    }
                }

                if (errors.length > 0 || !amountSelectorOk) {
                    return;
                }

                let pid = _self.methods.getPidValue($(e.currentTarget));
                uuid = $(e.currentTarget).data('uid');

                let country = $('#countrySelector').val();
                let destinationName = $('.js-giftcardNameTo').val();
                let destinationMail = $('#giftcard--mail-to').val();
                let senderName = $('.js-giftcardYourName').val();
                let message = $('#contact-form-message').val();
                let amount = $('.js-amount-selector.active').attr('data-amount');

                let dateString = $('.datepickerTriggerElement').data('date');
                if (dateString.match(/-/g).length !== 2) {
                    dateString = formatDate(new Date(dateString));
                }

                let imgUrl = $('.js-giftcard-swatch.slick-current img').attr('src');
                let imgCodes = imgUrl.split('/');
                let imgCode = imgCodes[imgCodes.length - 1].replace('.jpg', '');

                form = {
                    pid: pid,
                    quantity: 1,
                    uuid: uuid,
                    destinationName: destinationName,
                    destinationMail: destinationMail,
                    message: message,
                    senderName: senderName,
                    amount: amount,
                    shippingDate: dateString,
                    country: country,
                    imageCode: imgCode,
                    imgUrl: imgUrl
                };
            }

            $.spinner().start();
            if (updateProductUrl) {
                $.ajax({
                    url: updateProductUrl,
                    type: 'post',
                    context: this,
                    data: form,
                    dataType: 'json',
                    success: function (data) {
                        location.reload();
                    },
                    error: function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            createErrorNotification(err.responseJSON.errorMessage);
                            $.spinner().stop();
                        }
                    }
                });
            }
        });
        $('body').on('product:quickUpdateProductSaveForLater', function (e, data) {
            e.preventDefault();
            var $productContainer = data.container;

            var oldSku = data.skuOld;
            var sku = data.newProductId;
            var form = {
                oldSku: oldSku,
                sku: sku
            };
            var addToCartUrl = $productContainer.data('sflUpdateUrl');

            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: data => {
                        if (data.error) {
                            createErrorNotification(data.msg);
                            $.spinner().stop();
                        } else {
                            if ($('.page').data('action') === 'Cart-Show') {
                                window.location.reload();
                            }
                        }
                    },
                    error: () => {
                    }
                });
            }
        });
        $('body').on('product:quickUpdateBonusProduct', (e, data) => {
            var $productContainer = data.container;

            var url = $productContainer.data('bonusProductUpdateUrl');
            var queryString = '?pids=';
            var pid = data.newProductId;
            var uuid = $productContainer.data('uuid');
            var pliuuid = $productContainer.data('pliuuid');

            var pidsObject = {
                bonusProducts: [{
                    pid: decodeURI(pid),
                    qty: 1,
                    options: [null],
                    GTMItemListName: 'free_product',
                    GTMItemListId: getListId($productContainer),
                    GTMIndex: 0
                }],
                totalQty: 1
            };

            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + uuid;
            queryString = queryString + '&pliuuid=' + pliuuid;

            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: data => {
                    if (data.error) {
                        createErrorNotification(data.errorMessage);
                        $.spinner().stop();
                    } else {
                        var bonusProductPid = JSON.parse(JSON.parse('{"' + decodeURIComponent(data.queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}').pids).bonusProducts[0].pid;
                        $('body').trigger('product:afterAddToCart', {
                            ...data,
                            form: {
                                pid: bonusProductPid,
                                quantity: pidsObject.bonusProducts[0].qty
                            },
                            $productContainer: 'bonus_product'
                        });
                    }
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        });
    }

    quickUpdateListener () {
        $('body').on('product:forceQuickUpdateSizeSelection', function (e, data) {
            const $productContainer = data.container;

            const sizeDropdown = $productContainer.find('.accordion-title.js-sizeEditTitle');

            // Open sizes dropdown to force size selection
            $productContainer.find('[data-attr-type-qu="size"] .selected-attribute-label').data('value', '').text('');
            $productContainer.find('.js-colorEditTitle').trigger('click');
            sizeDropdown.trigger('click');
        });

        $('body').on('product:sizeNotSelected', function (e, data) {
            const $productContainer = data.container;

            $productContainer.find('[data-attr-type-qu="size"] .selected-attribute-label').data('value', '').text('').hide();
            $productContainer.find('[data-attr-type-qu="size"] .not-selected-attribute-label').show();

            if (isQuickUpdateFromModal()) {
                // disable proceed button
                $productContainer.find('.js-proceed-quickUpdate-modal').addClass('disabled');
            } else if (isChooseBonusProductModalOpen()) {
                // enable size accordion
                $productContainer.find('[data-attr-type-qu="size"] .accordion-title').removeClass('disabled');
                // disable proceed button
                $productContainer.find('.js-proceed-chooseBonusProduct-modal').addClass('disabled');
            }

            // disable Checkout CTA
            // add cart error message
            $('.js-cart-size-notSelected').show();
        });

        $('body').on('product:colorNotSelected', function (e, data) {
            const $productContainer = data.container;

            $productContainer.find('[data-attr-type-qu="color"] .selected-attribute-label').data('value', '').text('').hide();
            $productContainer.find('[data-attr-type-qu="color"] .not-selected-attribute-label').show();

            if (isQuickUpdateFromModal()) {
                $productContainer.find('.js-proceed-quickUpdate-modal').removeClass('disabled');
            } else if (isChooseBonusProductModalOpen()) {
                $productContainer.find('[data-attr-type-qu="color"] .accordion-title').removeClass('disabled');
                $productContainer.find('.js-proceed-chooseBonusProduct-modal').addClass('disabled');
            }
        });

        $('body').on('product:colorSelected', function (e, data) {
            const $productContainer = data.container;
            const value = data.value;
            const description = data.description;

            $productContainer.find('[data-attr-type-qu="color"] .not-selected-attribute-label').hide();
            $productContainer.find('[data-attr-type-qu="color"] .family-color').data('value', description.toLowerCase() + ' - ').text(description.toLowerCase() + ' - ').show();
            $productContainer.find('[data-attr-type-qu="color"] .selected-attribute-label').data('value', value).text(value).show();

            if (isQuickUpdateFromModal()) {
                // enable proceed button
                $productContainer.find('.js-proceed-quickUpdate-modal').removeClass('disabled');
            } else if (isChooseBonusProductModalOpen()) {
                const selectedColorSwatchHTML = $productContainer.find('[data-attr-type-qu="color"] .selected .color-option-span').html();
                $productContainer.find('[data-attr-type-qu="color"] .js-color-swatch').html(selectedColorSwatchHTML);
                // enable proceed button
                $productContainer.find('.js-proceed-chooseBonusProduct-modal').removeClass('disabled');
            }

            // enable Checkout CTA if disabled
            // remove cart error message
            if ($('#checkout-button-secure-checkout').prop('disabled') === true) {
                $('#checkout-button-secure-checkout').prop('disabled', false);
            }
        });

        $('body').on('product:sizeSelected', function (e, data) {
            const $productContainer = data.container;
            const value = data.value;

            $productContainer.find('[data-attr-type-qu="size"] .not-selected-attribute-label').hide();
            $productContainer.find('[data-attr-type-qu="size"] .selected-attribute-label').data('value', value).text(value).show();
            $productContainer.find('.js-dangerLabel-soldOut').find('.not-available-size-label').data('value', value).text(value);
            $productContainer.find('.js-quickUpdateModal-container').find('.js-soldOut-message').find('.not-available-size-label').data('value', value).text(value);

            if (isQuickUpdateFromModal()) {
                // enable proceed button
                $productContainer.find('.js-proceed-quickUpdate-modal').removeClass('disabled');
            } else if (isChooseBonusProductModalOpen()) {
                // enable proceed button
                $productContainer.find('.js-proceed-chooseBonusProduct-modal').removeClass('disabled');
            }

            // enable Checkout CTA if disabled
            // remove cart error message
            $('.js-cart-size-notSelected').hide();
            if ($('#checkout-button-secure-checkout').prop('disabled') === true) {
                $('#checkout-button-secure-checkout').prop('disabled', false);
            }
        });

        $('body').on('click', '.js-color-variation', function (e) {
            e.preventDefault();
            if ($(e.currentTarget).attr('disabled') || $(e.currentTarget).hasClass('disabled') || $(e.currentTarget).hasClass('selected')) {
                return;
            }

            const imagesShouldUpdate = false;
            let $productContainer = $(e.currentTarget).closest('.product-detail');
            const skuOld = $(e.currentTarget).data('skuOld');
            attributeSelectQuickUpdate(e.currentTarget.href, $productContainer, 'color', imagesShouldUpdate, skuOld);

            $('body').trigger('product:didChangeColorFromCart', {
                promotionType: $productContainer.find('.analytics.checkout-product').data('coupon'),
                sku: $productContainer.data('pid')
            });
        });

        $('body').on('click', '.js-size-variation', function (e) {
            e.preventDefault();
            if ($(e.currentTarget).attr('disabled') || $(e.currentTarget).hasClass('disabled') || $(e.currentTarget).hasClass('size-button--selected')) {
                return;
            }
            const $anchorTarget = $(e.currentTarget).find('a');
            const $productContainer = $anchorTarget.closest('.product-detail');
            const imagesShouldUpdate = false;
            const skuOld = $(e.currentTarget).data('skuOld');

            attributeSelectQuickUpdate($anchorTarget.attr('href'), $productContainer, 'size', imagesShouldUpdate, skuOld);

            let productSku = $productContainer.data('pid').replace(/\s+/g, '_color_');
            $('body').trigger('product:didChangeSize', {
                size: $(e.currentTarget).data('attr-value'),
                sku: productSku.substring(0, productSku.length - 2)
            });
        });

        $('body').on('click', '.js-open-quickUpdate-modal', function (e) {
            let $productContainer = $(e.currentTarget).closest('.product-detail');

            // prepare modal content
            const htmlContent = $(e.currentTarget).closest('.product-info').find('.js-quickUpdateModalContent').html();

            // create and open modal
            const modal = newModalFromString(htmlContent, false, ['cc-quickUpdateModal', 'js-quickUpdateModal', 'product-detail'], null, function () {
                $('.js-cart-size-notSelected').hide();
            });

            $(modal.modalBox).addClass('rightModalAttribute');

            // Copy all data attributes from the productContainer to the modal box
            const dataAttributes = $productContainer[0].attributes;
            for (var i = 0; i < dataAttributes.length; i++) {
                var attr = dataAttributes[i];
                if (attr.name.startsWith('data-')) {
                    $(modal.modalBox).attr(attr.name, attr.value);
                }
            }

            // Set first modal step as 'color'
            $(modal.modalBox).data('step', 'color');
            $(modal.modalBox).find('.js-back-quickUpdate-modal').hide();
            $(modal.modalBox).find('.js-sizeContainer').hide();

            // Retrieve selected variation url
            const selectedColorUrl = $(modal.modalBox).find('.js-color-variation.selected').attr('href');
            $(modal.modalBox).find('.js-proceed-quickUpdate-modal').attr('href', selectedColorUrl);

            const $modalContainer = $(modal.modalBox);
            modal.open();

            $(modal.modalBox).find('.js-proceed-quickUpdate-modal').on('click', (e) => {
                const step = $modalContainer.data('step');
                const selectedColor = $modalContainer.find('[data-attr-type-qu="color"] .selected-attribute-label').data('value');
                const selectedSize = $modalContainer.find('[data-attr-type-qu="size"] .selected-attribute-label').data('value');

                if (step === 'color' && (selectedColor && selectedColor !== '')) {
                    $modalContainer.data('step', 'size');
                    $modalContainer.find('.js-colorContainer').hide();
                    $modalContainer.find('.js-sizeContainer').show();
                    $modalContainer.find('.js-back-quickUpdate-modal').show();

                    if (!selectedSize || selectedSize === '') {
                        $('body').trigger('product:sizeNotSelected', {
                            container: $modalContainer
                        });
                        $('body').trigger('product:forceQuickUpdateSizeSelection', {
                            container: $modalContainer
                        });
                    }
                    $.spinner().stop();
                }

                if (step === 'size' && (selectedColor && selectedColor !== '') && (selectedSize && selectedSize !== '')) {
                    const newProductId = $(e.currentTarget).data('pid');
                    const skuOld = $(e.currentTarget).data('skuOld');

                    if ($modalContainer.data('isBonusProduct') === true) {
                        $('body').trigger('product:quickUpdateBonusProduct', {
                            newProductId: newProductId,
                            container: $modalContainer
                        });
                    } else if ($productContainer.data('isSaveForLater') === true) {
                        $('body').trigger('product:quickUpdateProductSaveForLater', {
                            newProductId: newProductId,
                            container: $productContainer,
                            skuOld: skuOld
                        });
                    } else {
                        if ($('.page').data('action') === 'Wishlist-Show') {
                            $('body').trigger('wishlist:quickUpdateProduct', {
                                newProductId: newProductId,
                                container: $modalContainer
                            });
                        } else {
                            $('body').trigger('product:quickUpdateProduct', {
                                newProductId: newProductId,
                                container: $modalContainer
                            });
                        }
                    }
                }
            });

            $(modal.modalBox).find('.js-back-quickUpdate-modal').on('click', (e) => {
                $modalContainer.find('.js-back-quickUpdate-modal').hide();
                $modalContainer.find('.js-sizeContainer').hide();
                $modalContainer.find('.js-colorContainer').show();
                $modalContainer.data('step', 'color');
                // enable proceed button
                $modalContainer.find('.js-proceed-quickUpdate-modal').removeClass('disabled');
            });

            // prepare handler - close modal from a close icon as well as from a cancel button.
            $('[data-dismiss="modal"],.js-quickUpdateModal-closeIcon').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });
        });
    }

    showFreeGiftDetails () {
        $('body').on('click', '.js-showFreeGiftDetails', e => {
            e.preventDefault();

            // prepare modal content
            const htmlContent = document.getElementById(this.freeGiftDetailsModal).innerHTML;

            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false, ['cc-freeProductModal']);
            if (!Foundation.MediaQuery.atLeast('large')) {
                $(modal.modalBox).addClass('rightModalAttribute');
            }
            moveModalCloseButton();
            modal.open();

            // prepare handler - close modal from a close icon as well as from a cancel button.
            $('[data-dismiss="modal"]').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });

            this.currentlyOpenedModal = modal;
        });
    }
}

// Create an instance of QuickUpdate
const QuickUpdate = QuickUpdateSingleton.getInstance();
export default QuickUpdate;
